import React, {
  InputHTMLAttributes,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

import { useField } from '@unform/core';
import { FiEye, FiEyeOff } from 'react-icons/fi';

import InputError from '../InputError';

import { colors } from 'styles';

import * as S from './styles';

interface IInputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  containerStyle?: {};
  type?: string;
  containerClassName?: string;
  required?: boolean;
}

const InputWithLabel: React.FC<IInputProps> = ({
  name,
  label,
  containerStyle = {},
  type = 'text',
  containerClassName,
  required = false,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isPassword] = useState(type === 'password' && true);
  const [passwordVisible, setPasswordVisible] = useState(true);

  const { fieldName, defaultValue, error, registerField } = useField(name);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const handleVisiblePassword = useCallback(() => {
    setPasswordVisible(state => !state);
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <S.Container
      style={containerStyle}
      isErrored={!!error}
      isFocused={isFocused}
      className={`input-with-label${
        containerClassName ? ` ${containerClassName}` : ''
      }${isPassword ? ' isPassword' : ''}
    }`}
    >
      <label
        htmlFor={name}
        className={`${required ? 'required' : ''}
            }`}
      >
        {label}
      </label>

      <div className="input-and-password">
        <input
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
          defaultValue={defaultValue}
          ref={inputRef}
          type={isPassword ? (passwordVisible ? type : 'text') : type}
          {...rest}
        />

        {isPassword && (
          <span className="password" onClick={handleVisiblePassword}>
            {passwordVisible ? (
              <FiEye color={colors.text_black} />
            ) : (
              <FiEyeOff color={colors.text_black} />
            )}
          </span>
        )}
      </div>

      {error && <InputError title={error} />}
    </S.Container>
  );
};

export default InputWithLabel;
